import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { PreloginService } from '../../services/prelogin.service';
import { Subscription } from 'rxjs';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  showSidebar;
  // regex = RegExp('(\/([a-zA-Z0-9-]+)\/)');

  loggedInUserDetails;
  userRole;   // 0 - Partner, 1 - Admin, 2 - Counsellor
  isPartner;
  isAdmin;

  constructor(private router: Router, private dashboardService: DashboardService, private preLoginService: PreloginService) {

    // subscribe to header menu flag
    // this.dashboardService.getSidebarFlag().subscribe(data => {
    //   this.showSidebar = data;
    // });

  }

  ngOnInit() {

    // toggle (hide) sidebar if the the route changes (mobile screen)
    this.router.events.subscribe((event: Event) => {

      // If, want to execute specific code only for a particular screen size, then use below with if statement -
      // console.log('window width - ', window.innerWidth);
      if (event instanceof NavigationStart) {
        // if (event.url != '/upgrade' && !this.regex.test(event.url)) {
        //   this.showSidebar = !this.showSidebar;
        // }
        // scroll to top on route change
        // (on mobile - if user is at the last of a page and goes to different page (long page),
        // then the new screen appears at the same scroll position i.e. last. So, to fix this below line is used)
        window.scrollTo(0, 0);
      }
    });

    this.loggedInUserDetails = this.dashboardService.decodeToken();

    this.userRole = this.preLoginService.getCurrentRole();

    // 0 - Partner, 1 - Admin, 2 - Counsellor
    if (this.userRole === 0) {
      this.isPartner = true;
    }
    else if (this.userRole === 1) {
      this.isAdmin = true;
    }
  }

  toggleSidebar() {
    this.showSidebar = !this.showSidebar;
  }

  logOut() {
    localStorage.clear();

    this.preLoginService.setLoggedInFlagForNav(false);

    this.router.navigate(['/login']);
  }

}
